"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _usePalette2 = _interopRequireDefault(require("../styles/PaletteProvider/usePalette"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2["default"])(),
      colors = _useTheme.colors,
      fonts = _useTheme.fonts;

  var _usePalette = (0, _usePalette2["default"])(),
      typography = _usePalette.typography;

  var message = typography.message;
  return {
    root: {
      color: colors[message]
    },
    message1: fonts.messageLarge,
    message2: fonts.messageMedium,
    message3: fonts.messageSmall,
    message4: fonts.messageExtraSmall
  };
};

__signature__(useStyles, "useTheme{{ colors, fonts }}\nusePalette{{ typography }}", function () {
  return [_useTheme2["default"], _usePalette2["default"]];
});

var Message = function Message(props) {
  var _props$as = props.as,
      Element = _props$as === void 0 ? 'span' : _props$as,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'message4' : _props$variant,
      inactive = props.inactive,
      other = (0, _objectWithoutProperties2["default"])(props, ["as", "variant", "inactive"]);
  var classes = useStyles();
  return (0, _core.jsx)(Element, (0, _extends2["default"])({
    css: /*#__PURE__*/(0, _css2["default"])([classes.root, classes[variant]], ";label:Message;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9UZXh0L01lc3NhZ2UudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXFDa0IiLCJmaWxlIjoiLi4vLi4vc3JjL1RleHQvTWVzc2FnZS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgeyBDU1NPYmplY3QgfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcblxuaW1wb3J0IHVzZVBhbGV0dGUgZnJvbSAnLi4vc3R5bGVzL1BhbGV0dGVQcm92aWRlci91c2VQYWxldHRlJztcbmltcG9ydCB1c2VUaGVtZSBmcm9tICcuLi9zdHlsZXMvdXNlVGhlbWUnO1xuaW1wb3J0IHsgR2VuZXJpY0NvbXBvbmVudCwgV2l0aEFzUHJvcCB9IGZyb20gJy4uL3R5cGVzL3dpdGgtYXMtcHJvcCc7XG5cbmV4cG9ydCB0eXBlIE1lc3NhZ2VWYXJpYW50ID0gJ21lc3NhZ2UxJyB8ICdtZXNzYWdlMicgfCAnbWVzc2FnZTMnIHwgJ21lc3NhZ2U0JztcblxuZXhwb3J0IHR5cGUgTWVzc2FnZVByb3BzPFQgZXh0ZW5kcyBHZW5lcmljQ29tcG9uZW50ID0gJ3NwYW4nPiA9IFdpdGhBc1Byb3A8VD4gJiB7XG4gIHZhcmlhbnQ/OiBNZXNzYWdlVmFyaWFudDtcbiAgaW5hY3RpdmU/OiBib29sZWFuO1xufTtcblxuY29uc3QgdXNlU3R5bGVzID0gKCk6IENTU09iamVjdCA9PiB7XG4gIGNvbnN0IHsgY29sb3JzLCBmb250cyB9ID0gdXNlVGhlbWUoKTtcblxuICBjb25zdCB7IHR5cG9ncmFwaHkgfSA9IHVzZVBhbGV0dGUoKTtcbiAgY29uc3QgeyBtZXNzYWdlIH0gPSB0eXBvZ3JhcGh5O1xuXG4gIHJldHVybiB7XG4gICAgcm9vdDoge1xuICAgICAgY29sb3I6IGNvbG9yc1ttZXNzYWdlXSxcbiAgICB9LFxuICAgIG1lc3NhZ2UxOiBmb250cy5tZXNzYWdlTGFyZ2UsXG4gICAgbWVzc2FnZTI6IGZvbnRzLm1lc3NhZ2VNZWRpdW0sXG4gICAgbWVzc2FnZTM6IGZvbnRzLm1lc3NhZ2VTbWFsbCxcbiAgICBtZXNzYWdlNDogZm9udHMubWVzc2FnZUV4dHJhU21hbGwsXG4gIH07XG59O1xuXG5jb25zdCBNZXNzYWdlID0gPFQgZXh0ZW5kcyBHZW5lcmljQ29tcG9uZW50ID0gJ3NwYW4nPihwcm9wczogTWVzc2FnZVByb3BzPFQ+KSA9PiB7XG4gIGNvbnN0IHsgYXM6IEVsZW1lbnQgPSAnc3BhbicsIHZhcmlhbnQgPSAnbWVzc2FnZTQnLCBpbmFjdGl2ZSwgLi4ub3RoZXIgfSA9IHByb3BzO1xuXG4gIGNvbnN0IGNsYXNzZXMgPSB1c2VTdHlsZXMoKTtcblxuICByZXR1cm4gPEVsZW1lbnQgY3NzPXtbY2xhc3Nlcy5yb290LCBjbGFzc2VzW3ZhcmlhbnRdXX0gey4uLm90aGVyfSAvPjtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IE1lc3NhZ2U7XG4iXX0= */"))
  }, other));
};

__signature__(Message, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = Message;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Text/Message.tsx");
  reactHotLoader.register(Message, "Message", "/builds/bA1zbJom/0/gojob/ui-bits/src/Text/Message.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Text/Message.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();